import parseFullImageSrc from './parseFullImageSrc';

export default parseFullImageSrc;
